$(() => {
    $('a[target="_blank"]').on('click', (e) => {
        let confirmation = confirm("Are you sure you want to leave ?");
        if (!confirmation) {
            e.preventDefault();
        }
    });
});
